import type {
  DateTimeType,
  DateTimeValue
} from '@elfsight/configurator-contracts';

export function getDateByDateTimeValue(
  value: DateTimeValue<DateTimeType> | undefined,
  timeZone?: string
): Date {
  const day = new Date(new Date().toLocaleString('en', { timeZone }));

  if (!value) {
    return day;
  }

  const time =
    value.type !== 'date' ? value.time.split(':').map(Number) : [0, 0];

  if (value.type !== 'time') {
    const date = value.date.split('-');
    day.setFullYear(
      parseInt(date[0]),
      parseInt(date[1]) - 1,
      parseInt(date[2].split('T')[0])
    );
  }

  day.setHours(time[0], time[1], 0, 0);

  return day;
}
